import { useEffect, useState } from "react";

/**
 * Types each phrase out, holds it, deletes it, then moves to the next one.
 * Returns the currently visible text slice.
 */
export function useTypewriter(phrases, { type = 55, erase = 28, hold = 1800 } = {}) {
    const [index, setIndex] = useState(0);
    const [len, setLen] = useState(0);
    const [erasing, setErasing] = useState(false);

    useEffect(() => {
        const word = phrases[index % phrases.length];

        if (!erasing && len === word.length) {
            const t = setTimeout(() => setErasing(true), hold);
            return () => clearTimeout(t);
        }
        if (erasing && len === 0) {
            setErasing(false);
            setIndex((i) => (i + 1) % phrases.length);
            return undefined;
        }
        const t = setTimeout(
            () => setLen((l) => l + (erasing ? -1 : 1)),
            erasing ? erase : type
        );
        return () => clearTimeout(t);
    }, [len, erasing, index, phrases, type, erase, hold]);

    return phrases[index % phrases.length].slice(0, len);
}
